import { useQuery } from '@tanstack/react-query';
import type { IPaginationParams } from 'v2/interfaces/pagination';
import productService from 'v2/services/product';

export const useCoProductions = (pagination: IPaginationParams, search: string) => {
  const { data: response, isFetching } = useQuery({
    queryKey: ['coProductions', pagination.current_page, pagination.per_page, search],
    queryFn: () => productService.listCoProductions(pagination, search)
  });

  return {
    data: response?.data ?? [],
    pagination: response?.pagination,
    isFetching
  };
};
